import axios from 'axios';
import { SETTINGS } from '../../config/settings';

const baseURL = SETTINGS.public.urlOrderSvc;

const apiClient = axios.create({
  baseURL,
  headers: {
    'Content-Type': 'application/json',
  },
  withCredentials: true,
});

export default apiClient;
